// extracted by mini-css-extract-plugin
export default {"overlay":"OverlayLink_overlay__ZgTox"};